import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=a34f58da&scoped=true&"
import script from "./Prices.vue?vue&type=script&lang=js&"
export * from "./Prices.vue?vue&type=script&lang=js&"
import style0 from "./Prices.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Prices.vue?vue&type=style&index=1&id=a34f58da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34f58da",
  null
  
)

export default component.exports